<template>
  <div style="width: 100%;    font-size: 0;">
    <img :src="img" width="100%"/>
  </div>
</template>

<script>
    export default {
        name: "banner-nav",
        data(){
          return{
              img:'static/5ab7dc04N7a80a2d9.jpg!cr_1125x549_0_72!q70.jpg'
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Index/bannerNav.vue